import { FC, ReactNode } from 'react';
import Loader from './index';
import { LOADING } from '../../../constants';

interface WithLoadingProps {
  loading: boolean;
  fallback?: ReactNode;
  children: ReactNode;
}

const WithLoading = ({ loading, fallback, children } : WithLoadingProps) => {
  if (loading) {
    return fallback ? <>{fallback}</> : <Loader size={32} secondary={LOADING} />;
  }
  return <>{children}</>;
};

export default WithLoading;